import { render, staticRenderFns } from "./VouchersBuy.vue?vue&type=template&id=7129bb66&"
import script from "./VouchersBuy.vue?vue&type=script&lang=js&"
export * from "./VouchersBuy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7129bb66')) {
      api.createRecord('7129bb66', component.options)
    } else {
      api.reload('7129bb66', component.options)
    }
    module.hot.accept("./VouchersBuy.vue?vue&type=template&id=7129bb66&", function () {
      api.rerender('7129bb66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwg/js/components/VouchersBuy.vue"
export default component.exports